<template>
  <portlet
          :icon="'fad fa-building'"
          :title="'Bedrijf gegevens'"
          :actionsBlock="true"
          :footer="true"
  >

    <template slot="portletBody">
      <div class="row">
        <div class="form-group col-lg-4">
          <label for="customer-name">Naam</label>
          <input
                  v-validate="'required'"
                  name="name"
                  id="customer-name"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.name"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('name')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-alias">Alias</label>
          <input
                  v-validate="'required'"
                  name="alias"
                  id="customer-alias"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.alias"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('alias')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-8 col-lg-3">
          <label for="customer-zipcode">Postcode</label>
          <input
                  v-validate="'required'"
                  name="zipcode"
                  id="customer-zipcode"
                  type="text"
                  @keyup="uppercaseZipCode()"
                  class="form-control"
                  v-model="editCustomer.zipcode"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('zipcode')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-4 col-lg-1 rm-p-l">
          <label for="customer-nr">Nr</label>
          <input
                  v-validate="'required'"
                  name="nr"
                  id="customer-nr"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.nr"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('nr')" class="small text-danger">Dit veld is verplicht</span>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-4">
          <label for="customer-street">Straatnaam</label>
          <input
                  v-validate="'required'"
                  name="street"
                  id="customer-street"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.street"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('street')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-location">Woonplaats</label>
          <input
                  v-validate="'required'"
                  name="location"
                  id="customer-location"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.location"
                  @change="addLocationToDepartments"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('location')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-location">Vestigingen</label>
          <tags-input element-id="tags"
                      placeholder="Voeg vestiging toe en druk op enter"
                      display-field="Alle vestigingen"
                      typeahead-style="dropdown"
                      v-model="editCustomer.departments"></tags-input>
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-telephone">Telefoonnummer</label>
          <input
                  v-validate="'required'"
                  name="telephone"
                  id="customer-telephone"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.telephone"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('telephone')" class="small text-danger">Dit veld is verplicht</span>
        </div>

        <div class="form-group col-lg-4">
          <label for="customer-website">Website</label>
          <input
                  name="customer-website"
                  id="customer-website"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.website"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-telephone">E-mailadres</label>
          <input
                  v-validate="'required|email'"
                  name="E-mailadres"
                  id="customer-email"
                  type="email"
                  class="form-control"
                  v-model="editCustomer.email"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
          <span v-if="errors.first('E-mailadres')" class="small text-danger">{{errors.first('E-mailadres')}}</span>
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-contact">Contactpersoon</label>
          <input
                  name="customer-contact"
                  id="customer-contact"
                  type="text"
                  class="form-control"
                  v-model="editCustomer.contact"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          />
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-cost-center">Kostenplaats</label>
          <select
                  name="customer-cost-center"
                  id="customer-cost-center"
                  class="form-control"
                  v-model="editCustomer.costCenter"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          >
            <option value="">Geen</option>
            <option v-for="costCenter in costCenterOptions" :value="costCenter" :key="costCenter">
              {{costCenter}}
            </option>
          </select>
        </div>
        <div class="form-group col-lg-4">
          <label for="customer-responsibleUser">Verantwoordelijke</label>
          <v-select
                  :options="departmentUsers"
                  :selectOnTab="true"
                  id="customer-responsibleUser"
                  :get-option-label="getUserLabel"
                  v-model="editCustomer.responsibleUser"
                  :disabled="!Can(rights.CUSTOMER_EDIT)"
          >
            <div slot="no-options">Geen gebruikers gevonden</div>
          </v-select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-4">
          <label for="purchasing-factor">Inkoop factor</label>
          <input
                  name="purchasing-factor"
                  id="purchasing-factor"
                  type="number"
                  step=".1"
                  class="form-control"
                  v-model="customer.purchasingFactor"
          />
        </div>
        <div class="form-group col-lg-4">
          <label for="sale-factor">Verkoop factor</label>
          <input
                  name="sale-factor"
                  id="sale-factor"
                  type="number"
                  step=".1"
                  class="form-control"
                  v-model="customer.saleFactor"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="customer-description">Omschrijving (interne notities)</label>
          <textarea
                  rows="8"
                  id="customer-description"
                  name="customer-description"
                  class="form-control"
                  v-model="editCustomer.description"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="customer-defaultInstructions">Welkomst e-mail standaard</label>
          <tiptap-editor
                  v-model="editCustomer.defaultInstructions"
                  :disableEdit="isAdmin"
                  :content="editCustomer.defaultInstructions"/>
        </div>
      </div>
    </template>
    <div slot="portletFooter" class="col text-right">
      <button @click="saveCustomer" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
  import Vue from 'vue';
  import {mapGetters} from 'vuex';
  import {getPostalData} from '../mixins/getPostalData';
  import { Can } from '../../../permission/ability';
  import { RIGHTS } from '../../views/roles/rights';

  const HOUR_APP_KEEPS_OLD_NAME = 'De naam in de urenapp is niet bijgewerkt.';

  const RENAME_BROKE_OFF = {ok: false, message: null};

  export default {
    props: ['id', 'customer'],
    mixins:[getPostalData],
    data() {
      return {
        rights: '',
        isAdmin: false,
        renderedComponent: true,
        customerCopy: null,
        departmentUsers: [],
        editCustomer: {
          name: '',
          alias: '',
          postcode: '',
          nr: '',
          street: '',
          location: '',
          telephone: '',
          email: '',
          website: '',
          contact: '',
          purchasingFactor: null,
          saleFactor: null,
          description: '',
          defaultInstructions: '',
          departments: [],
          responsibleUser: null,
        }
      };
    },
    methods: {
      Can,
      addLocationToDepartments() {
        if(!this.editCustomer.departments || !this.editCustomer.departments.length) {
          this.editCustomer.departments = [ {key: '' , value: this.editCustomer.location } ];
        }
      },
      uppercaseZipCode() {
        this.editCustomer.zipcode = this.editCustomer.zipcode.toUpperCase();
      },
      getCandidateLabel(option) {
        return `${option.firstName} ${option.lastName}`;
      },
      getUserLabel(user) {
        return `${user.firstname} ${user.lastname}`;
      },
      loadDepartmentUsers() {
        this.$store.dispatch('users/getAllUsers', {
          ApiClient: Vue.prototype.$ApiClient,
          departments: [{name: this.$store.getters.getUserData.selectedDepartment}]
        }).then((res) => {
          if (res.status === 200) {
            this.departmentUsers = _.orderBy(res.data.users.filter(user => user.hasOwnProperty('email')).map(user => ({
              id: user.uid,
              firstname: user.firstname,
              lastname: user.lastname,
            })), ['firstname', 'lastname']);
          }
        }).catch((err) => {
          console.error(err);
        });
      },
      renderComponent() {
        this.renderedComponent = false;
        this.$nextTick(() => {
          this.renderedComponent = true;
        });
      },
      autoFillBasedOnPostal(customer) {
        let rege = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
        customer = this.editCustomer;
        if(customer.zipcode && customer.nr) {


          if(rege.test(customer.zipcode)) {
            this.$store.commit('setLoading', true);
            this.getPostalData(customer.zipcode,customer.nr).then(res => {
              if(res.status == 200) {
                let data = res.data;
                this.editCustomer.location = data.city;
                this.editCustomer.street = data.street;
                this.addLocationToDepartments()
              }
            }).catch(e => {
              this.$store.commit('setLoading', false);

              console.error(e);
            }).finally(() => {
              this.$store.commit('setLoading', false);

            });
          }
        }
      },
      saveCustomer() {
        this.$validator.validate().then(result => {
          if(result) {
            this.customer.department = this.$store.getters.getUserData.selectedDepartment;
            this.customer.lastEditedBy = this.$store.getters.getUserData;
            this.customerCopy = this.customer;
            // Set current location as default
            if(!this.customer.departments || !this.customer.departments.length) {
              this.customer.departments = [ {key: '' , value: this.customer.location } ];
            }

            const savedName = this.customer.name;

            this.$store.dispatch('customers/set', this.customer).then(() => {
              this.$toasted.global.successRequest({
                message: 'Bedrijf aangepast'
              });

              this.$emit('unsavedChanges', false);

              this.syncNameToHourApp(savedName);
            }).catch(error => {
              this.$toasted.global.failedRequest();
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      },
      async syncNameToHourApp(name) {
        const outcome = await this.renameInHourApp(name).catch(() => RENAME_BROKE_OFF);

        if (!outcome.ok) {
          this.$toasted.global.failedRequest({message: [HOUR_APP_KEEPS_OLD_NAME, outcome.message].filter(Boolean).join(' ')});
        }
      },
      async renameInHourApp(name) {
        return this.$store.dispatch('organizations/renameByCustomerId', {
          ApiClient: Vue.prototype.$ApiClient,
          departments: this.$store.getters.getUserData.departments,
          customerId: this.customer.id,
          name,
        });
      }
    },
    computed: {
      ...mapGetters('costCenters', ['getCostCenters']),
      costCenterOptions() {
        const names = this.getCostCenters.map(costCenter => costCenter.name);
        // Keep a value that was removed from the list visible instead of silently dropping it
        if(this.editCustomer.costCenter && !names.includes(this.editCustomer.costCenter)) {
          names.push(this.editCustomer.costCenter);
        }
        return names;
      },
    },
    watch: {
      editCustomer: {
        handler: function (val, oldV, b) {


          this.$emit('unsavedChanges', JSON.stringify(val) !== JSON.stringify(this.customerCopy));


        },
        deep: true
      },
      'editCustomer.nr': function (newV, oldV) {
        this.autoFillBasedOnPostal(newV);
      },
      'editCustomer.zipcode': function (newV, oldV) {
        this.autoFillBasedOnPostal(newV);
      }
    },
    created() {
      this.rights = RIGHTS;
      this.editCustomer = this.customer;
      if(this.editCustomer.costCenter === undefined) {
        this.$set(this.editCustomer, 'costCenter', '');
      }
      this.customerCopy = JSON.parse(JSON.stringify(this.customer));
      this.isAdmin = this.$store.state.users.me.admin;
      this.loadDepartmentUsers();

      // Set current location as default
      if(!this.editCustomer.departments || !this.editCustomer.departments.length) {
        this.editCustomer.departments = [ {key: '', value: this.editCustomer.location }];
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-control:disabled {
    background-color: #f1f1f1;
  }
</style>
